import { CEZ_PATH } from "./consejoEmpresarialSumapazData";
import imgAsamblea from "../assets/cez/noticias/cez-noticia-asamblea.jpg";
import imgRueda from "../assets/cez/noticias/cez-noticia-rueda-negocios.jpg";
import imgPlateada from "../assets/cez/noticias/cez-noticia-plateada.jpg";
import imgFormacion from "../assets/cez/noticias/cez-noticia-formacion.jpg";

export const CEZ_NOTICIAS_PATH = `${CEZ_PATH}/noticias`;

const imagenes = {
  "asamblea-general-de-asociados-2026": imgAsamblea,
  "rueda-de-negocios-entre-afiliados": imgRueda,
  "sello-fusagasuga-plateada": imgPlateada,
  "formacion-para-el-empleo-del-sumapaz": imgFormacion,
};

const es = [
  {
    slug: "asamblea-general-de-asociados-2026",
    categoria: "Institucional",
    fecha: "2026-02-24",
    fechaLabel: "24 de febrero de 2026",
    titulo: "Asamblea General de Asociados 2026",
    resumen:
      "El Consejo Empresarial del Sumapaz convoca a sus afiliados a la primera Asamblea General, donde se aprueban los estatutos, el plan de trabajo y la cuota anual de la etapa fundacional.",
    autor: "Secretaría técnica del CEZ",
    cuerpo: [
      "El Consejo Empresarial del Sumapaz (CEZ) convoca a todos sus afiliados a la Asamblea General de Asociados 2026, que se realizará en Fusagasugá con la participación de empresarios de los diez municipios de la provincia.",
      "En la asamblea se aprueban tres puntos que definen el primer año del gremio: los estatutos y el código de conducta, el plan de trabajo por etapas y la cuota anual según el tamaño de cada empresa. Todo queda por escrito y se publica junto con las cuentas del periodo.",
      "La sesión también elige a los voceros de las cuatro mesas sectoriales —salud, construcción, turismo y agroindustria— y confirma la conformación de la junta directiva del primer periodo, en la que participan las empresas fundadoras.",
      "El principio es simple: un afiliado, un voto, sin importar el tamaño de la empresa. Las decisiones que se tomen en la asamblea son las que guían el trabajo de la secretaría técnica durante el año.",
    ],
    claves: [
      "Aprobación de estatutos y código de conducta.",
      "Plan de trabajo por etapas con indicadores verificables.",
      "Elección de voceros de las cuatro mesas sectoriales.",
      "Un afiliado, un voto, sin importar el tamaño de la empresa.",
    ],
  },
  {
    slug: "rueda-de-negocios-entre-afiliados",
    categoria: "Negocios",
    fecha: "2026-10-15",
    fechaLabel: "15 de octubre de 2026",
    titulo: "Primera rueda de negocios entre afiliados del Sumapaz",
    resumen:
      "Hoteles, centros de cuidado y restaurantes de la provincia se sientan con productores locales para reemplazar compras que hoy se hacen en Bogotá.",
    autor: "Mesa de agroindustria",
    cuerpo: [
      "La primera rueda de negocios del CEZ pone frente a frente a quien compra y a quien vende dentro de la provincia. La agenda se arma con anticipación: cada empresa llega con citas confirmadas y con una lista concreta de lo que necesita comprar durante el año.",
      "El objetivo no es un evento de relacionamiento más. Se trata de identificar qué se está comprando hoy en Bogotá que ya se puede comprar en el Sumapaz: alimentos, obra, mantenimiento, transporte y servicios profesionales.",
      "Los productores de café, mora, frutales, panela y lácteos presentan volúmenes reales de entrega y condiciones de pago. Del otro lado, hoteles, restaurantes, colegios y centros de cuidado exponen sus requisitos de calidad y frecuencia.",
      "La secretaría técnica hace seguimiento a los acuerdos y reporta en el boletín trimestral el monto de compras efectivamente realizadas entre afiliados. Ese número es el indicador que mide si la rueda funcionó.",
    ],
    claves: [
      "Agenda de citas armada antes del evento.",
      "Foco en compras que hoy salen de la provincia.",
      "Condiciones de pago y volúmenes acordados por escrito.",
      "Seguimiento publicado en el boletín trimestral.",
    ],
  },
  {
    slug: "sello-fusagasuga-plateada",
    categoria: "Fusagasugá Plateada",
    fecha: "2026-04-09",
    fechaLabel: "9 de abril de 2026",
    titulo: "Avanza el sello Fusagasugá Plateada para servicios al adulto mayor",
    resumen:
      "El capítulo del CEZ define los requisitos mínimos de calidad y trato que deberán cumplir las empresas que quieran usar el sello.",
    autor: "Comité Fusagasugá Plateada",
    cuerpo: [
      "Fusagasugá lleva décadas recibiendo a personas que llegan a vivir su etapa de retiro. Esa realidad sostiene un mercado que hoy se atiende a medias: buen cuidado, casas adaptadas, comida apropiada y actividades existen, pero sueltos y sin garantía.",
      "El sello Fusagasugá Plateada nace para poner reglas verificables. Una empresa que lo use se compromete con requisitos mínimos en calidad del servicio, trato al adulto mayor, precios claros desde el principio y personal formado.",
      "El comité del capítulo es una mesa mixta: participan los cuatro sectores, la academia local y la administración municipal como invitada permanente. Ninguna de las partes decide sola.",
      "La meta del año es tener el primer grupo de empresas certificadas y un mapa público de lo que existe y de lo que falta en la ciudad para atender bien a los adultos mayores.",
    ],
    claves: [
      "Requisitos mínimos verificables de calidad y trato.",
      "Precios claros desde el primer contacto.",
      "Personal formado en cuidado del adulto mayor.",
      "Mesa mixta con academia y administración municipal.",
    ],
  },
  {
    slug: "formacion-para-el-empleo-del-sumapaz",
    categoria: "Formación",
    fecha: "2026-05-06",
    fechaLabel: "6 de mayo de 2026",
    titulo: "Formación local para dejar de importar mano de obra calificada",
    resumen:
      "Talleres cortos y prácticos en cuidado del adulto mayor, obra segura, servicio al cliente y manejo de la caja, dictados con la academia local.",
    autor: "Mesa de talento del CEZ",
    cuerpo: [
      "Dos de los problemas que más repiten los empresarios de la provincia son los mismos: no se consigue personal calificado y el que se forma se va a Bogotá por mejor salario. El gremio decidió atacar el primero.",
      "El programa de formación del CEZ son talleres cortos y prácticos, diseñados con las empresas que van a contratar. Los primeros frentes son cuidado del adulto mayor, obra segura y acabados, servicio al cliente y manejo de la caja.",
      "La formación se dicta con la academia local y con instructores que trabajan en el sector. No son cursos genéricos: cada taller sale de una necesidad concreta levantada en la mesa sectorial correspondiente.",
      "El indicador es directo: cuántas personas se forman, cuántas se certifican y cuántas quedan vinculadas en empresas afiliadas. Ese dato se publica igual que los demás compromisos del gremio.",
    ],
    claves: [
      "Talleres diseñados con las empresas que contratan.",
      "Cuidado del adulto mayor, obra segura, servicio y caja.",
      "Instructores que trabajan en el sector.",
      "Seguimiento a personas formadas, certificadas y vinculadas.",
    ],
  },
];

const en = [
  {
    slug: "asamblea-general-de-asociados-2026",
    categoria: "Institutional",
    fecha: "2026-02-24",
    fechaLabel: "February 24, 2026",
    titulo: "2026 General Assembly of Members",
    resumen:
      "The Sumapaz Business Council calls its members to the first General Assembly, where the bylaws, the work plan, and the annual fee for the founding stage are approved.",
    autor: "CEZ technical secretariat",
    cuerpo: [
      "The Sumapaz Business Council (CEZ) invites all of its members to the 2026 General Assembly, to be held in Fusagasugá with business owners from the ten municipalities of the province.",
      "The assembly approves three items that define the council's first year: the bylaws and code of conduct, the staged work plan, and the annual fee based on company size. Everything is put in writing and published together with the year's accounts.",
      "The session also elects the spokespeople for the four sector tables — health, construction, tourism, and agribusiness — and confirms the board of directors for the first term, which includes the founding companies.",
      "The principle is simple: one member, one vote, regardless of company size. Whatever the assembly decides guides the technical secretariat's work throughout the year.",
    ],
    claves: [
      "Approval of bylaws and code of conduct.",
      "Staged work plan with verifiable indicators.",
      "Election of spokespeople for the four sector tables.",
      "One member, one vote, regardless of company size.",
    ],
  },
  {
    slug: "rueda-de-negocios-entre-afiliados",
    categoria: "Business",
    fecha: "2026-10-15",
    fechaLabel: "October 15, 2026",
    titulo: "First business matchmaking round among Sumapaz members",
    resumen:
      "Hotels, care centers, and restaurants in the province sit down with local producers to replace purchases currently made in Bogotá.",
    autor: "Agribusiness table",
    cuerpo: [
      "The CEZ's first matchmaking round brings buyers and sellers within the province face to face. The agenda is built in advance: every company arrives with confirmed meetings and a concrete list of what it needs to buy during the year.",
      "The goal is not another networking event. It is about identifying what is bought in Bogotá today that could already be bought in Sumapaz: food, construction, maintenance, transport, and professional services.",
      "Producers of coffee, blackberries, fruit, panela, and dairy present real delivery volumes and payment terms. On the other side, hotels, restaurants, schools, and care centers set out their quality and frequency requirements.",
      "The technical secretariat follows up on the agreements and reports in the quarterly bulletin how much was actually purchased among members. That figure is the indicator of whether the round worked.",
    ],
    claves: [
      "Meeting agenda built before the event.",
      "Focus on purchases that currently leave the province.",
      "Payment terms and volumes agreed in writing.",
      "Follow-up published in the quarterly bulletin.",
    ],
  },
  {
    slug: "sello-fusagasuga-plateada",
    categoria: "Silver Fusagasugá",
    fecha: "2026-04-09",
    fechaLabel: "April 9, 2026",
    titulo: "The Silver Fusagasugá seal for elder services moves forward",
    resumen:
      "The CEZ chapter defines the minimum quality and care standards that companies must meet to use the seal.",
    autor: "Silver Fusagasugá committee",
    cuerpo: [
      "Fusagasugá has spent decades welcoming people who come to live out their retirement. That reality sustains a market that today is only half served: good care, adapted homes, appropriate food, and activities exist, but scattered and without guarantees.",
      "The Silver Fusagasugá seal was created to set verifiable rules. A company using it commits to minimum standards in service quality, respectful care for older adults, clear prices from the start, and trained staff.",
      "The chapter committee is a mixed table: the four sectors, the local academic institutions, and the municipal administration as a permanent guest. No single party decides alone.",
      "The goal for the year is to have the first group of certified companies and a public map of what exists and what is missing in the city to properly serve older adults.",
    ],
    claves: [
      "Verifiable minimum standards of quality and care.",
      "Clear prices from the first contact.",
      "Staff trained in elder care.",
      "Mixed table with academia and municipal government.",
    ],
  },
  {
    slug: "formacion-para-el-empleo-del-sumapaz",
    categoria: "Training",
    fecha: "2026-05-06",
    fechaLabel: "May 6, 2026",
    titulo: "Local training to stop importing skilled labor",
    resumen:
      "Short, practical workshops in elder care, construction safety, customer service, and cash management, taught with local academic partners.",
    autor: "CEZ talent table",
    cuerpo: [
      "Two problems come up again and again among business owners in the province: skilled staff is hard to find, and those who get trained leave for Bogotá for better pay. The council decided to tackle the first one.",
      "The CEZ training program consists of short, practical workshops designed together with the companies that will hire. The first fronts are elder care, construction safety and finishes, customer service, and cash management.",
      "Training is delivered with local academic partners and instructors who work in the sector. These are not generic courses: each workshop comes from a concrete need raised at the relevant sector table.",
      "The indicator is straightforward: how many people are trained, how many are certified, and how many end up hired by member companies. That data is published like every other commitment of the council.",
    ],
    claves: [
      "Workshops designed with the companies that hire.",
      "Elder care, construction safety, service, and cash.",
      "Instructors who work in the sector.",
      "Tracking of people trained, certified, and hired.",
    ],
  },
];

const withImages = (items) =>
  items.map((item) => ({ ...item, imagen: imagenes[item.slug], path: `${CEZ_NOTICIAS_PATH}/${item.slug}` }));

export const cezNoticias = {
  es: withImages(es),
  en: withImages(en),
};

export const getCezNoticia = (lang, slug) => {
  const list = cezNoticias[lang] || cezNoticias.es;
  return list.find((item) => item.slug === slug);
};
